var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.127 5.254A1.127 1.127 0 1 0 2.127 3a1.127 1.127 0 0 0 0 2.254zm2.635 9.33c.205-1.679 1.992-2.511 3.587-1.952l.498.175c1.358.476 2.011 1.994 2.011 3.432 0 4.044 2.574 7.323 6.619 7.323a7.324 7.324 0 0 0 7.323-7.324c0-4.045-3.28-7.043-7.324-7.043a7.39 7.39 0 0 0-1.028.072c-1.772.247-3.832-.169-4.69-1.74-.773-1.413-.311-3.223 1.208-3.76A13.5 13.5 0 0 1 17.479 3c7.466 0 13.52 5.772 13.52 13.24 0 7.467-6.054 13.52-13.521 13.52-7.469 0-12.818-6.053-12.818-13.52 0-.561.034-1.114.1-1.657zm.463-3.274a1.972 1.972 0 1 0 0-3.944 1.972 1.972 0 0 0 0 3.944zM9.17 4.62a1.62 1.62 0 1 1-3.24 0 1.62 1.62 0 0 1 3.24 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxt);
export default __webpack_public_path__ + "static/media/OXT.9c16a6d61f61283a4814223e628ef22e.svg";
export { ForwardRef as ReactComponent };